<template>
  <com-header>
    <div class="examine">
      <div class="img">
        <img :src="resImg" alt="图片加载失败">
      </div>
      <h3>{{title}}</h3>
      <p>5-10个工作日审核通过，请耐心等候</p>
      <p>审核通过会有多比网的工作人员电话告知您</p>
      <p>也可以在多比网公众号获取审核信息状态</p>
    </div>
  </com-header>
</template>

<script>
import ComHeader from "./components/comHeader";
export default {
  metaInfo: { title: "后台资料审核中" },
  components: {
    ComHeader,
  },
  data() {
    return {
      resImg: undefined,
      title: "",
    };
  },
  mounted() {
    // console.log(this.$route.query.s);
    if (this.$route.query.s) {
      this.resImg = require("@/assets/img/settlement2.png");
      this.title = "后台工作人员快速审核中";
    } else {
      this.resImg = require("@/assets/img/settlement3.png");
      this.title = "资料提交成功";
    }
  },
};
</script>

<style lang="less" scoped>
.examine {
  text-align: center;
  padding: 1.6rem 0.3rem 0.3rem;
  .img {
    width: 3.6rem;
    height: auto;
    margin: 0 auto;
  }
  h3 {
    color: #f8b62d;
    font-weight: 500;
    padding-bottom: 0.3rem;
    letter-spacing: 0.06rem;
  }
  p {
    line-height: 0.6rem;
    font-size: 12px;
    color: #a3a3a3;
  }
}
</style>